import enableBindingToOthers from '../../mvvm/enableBindingToOthers';
import PropertyBindingFactory from '../../mvvm/PropertyBindingFactory';
export default class BabylonViewBase{
	constructor(props){
		const {model}=props;
	}
}
